import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type GetMerchantFinancialDocumentRequest = {
  merchantId: string;
  year: string;
  month: string;
};

async function getMerchantFinancialDocuments(
  data: GetMerchantFinancialDocumentRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Merchant/MerchantCurrentAccountHistory", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantFinancialReport() {
  return useMutation<BaseResponse<Array<any>>, Error, GetMerchantFinancialDocumentRequest>((variables) =>
    getMerchantFinancialDocuments(variables)
  );
}